"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ui_1 = require("@aperza/ui");
var ShippingPrice = function (props) {
    return (
    // convert the shippingPrice to string so that we don't get 'ASK' for 0 values
    react_1.default.createElement(ui_1.Price, { currency: 'JPY', price: '' + props.totalShippingPrice, openPrice: false }));
};
exports.default = ShippingPrice;
